<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <Packages />
    </div>
</template>

<script>
import currentUserQuery from '@views/Countries/Browse/queryCurrentUser.graphql';

import Packages from './Browse.vue';

export default {
  name: 'PackagesContainer',
  components: {
    Packages,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['developer', 'admin'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
